module.exports = __webpack_public_path__ + "static/media/IMG_0999.3e723999.jpg";